import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
@Component({
  selector: 'app-oops',
  templateUrl: './oops.component.html',
  styleUrls: ['./oops.component.css']
})
export class OopsComponent implements OnInit {

  constructor(private locations: Location) { }

  ngOnInit(): void {
  }

  backToLastLocation() {
    this.locations.back();
  }

}
